export const emailInfoProveedor = (data) =>
{
  return `
    <p>Hola,</p>
    <p>Has recibido un nuevo mensaje autom&aacute;tico de Sanfer:<br><br></p>
    <table style="border-collapse: collapse; width: 100%;" border="1">
      <tbody>
        <tr><td>Nombre del proveedor</td><td>${data.to_name}</td></tr>
        <tr><td>Correo del proveedor</td><td>${data.to_email}</td></tr>
        <tr><td>Tel&eacute;fono del proveedor</td><td>${data.to_phone}</td></tr>
        <tr><td>Compa&ntilde;&iacute;a</td><td>${data.to_company}</td></tr>
        <tr><td>Fecha de reserva</td><td>${data.to_date}</td></tr>
        <tr><td>N&uacute;mero de OC</td><td>${data.to_numOC}</td></tr>
        <tr><td>N&uacute;mero de factura</td><td>${data.to_numFac}</td></tr>
        <tr><td>Nombre del insumo</td><td>${data.to_numIn}</td></tr>
        <tr><td>Cantidad</td><td>${data.to_cant}</td></tr>
        <tr><td>Unidad de medida</td><td>${data.to_undmds}</td></tr>
        <tr><td>Contenedor</td><td>${data.to_container}</td></tr>
        <tr><td>N&uacute;mero de contenedores</td><td>${data.to_numContainers}</td></tr>
        <tr><td>Peso por contenedor</td><td>${data.to_weight}</td></tr>
        <tr><td>N&uacute;mero de Pallets</td><td>${data.to_numPallets}</td></tr>
        <tr><td>Condiciones de almacenamiento</td><td>${data.to_alm}</td></tr>
        <tr><td>Comentarios</td><td>${data.message}</td></tr>
        <tr><td>Folio</td><td>${data.folio}</td></tr>
      </tbody>
    </table>
    <p style="padding: 12px; border-left: 4px solid #d0d0d0; font-style: italic;">
      Por favor completa la cita haciendo clic en el siguiente enlace:<br><br>
      <a href="http://reservas.sanfer.com.mx/resumen/${data.folio}">
        Clic aqu&iacute; para finalizar el llenado de info con el siguiente folio ${data.folio}
      </a>
    </p>
    <p>Gracias.<br><br>Equipo Sanfer.</p>
  `;
};